import React from 'react';
const bSizes = ['w:44', 'w:56', 'w:48', 'w:44', 'w:56', 'w:48'];
export const OptionSizesSkeleton = ({ nbItems, sizes = bSizes }) => (React.createElement("div", { className: "mt:28 d:flex fd:column" },
    React.createElement("div", { className: "d:flex mb:16" },
        React.createElement("div", { className: "skeleton fz:14 h:lh w:1/5" })),
    React.createElement("div", { className: "d:flex fxw:wrap m:-6" }, [...Array(nbItems ?? sizes.length)].map((v, i) => (React.createElement("div", { className: "m:6 skeleton", key: i },
        React.createElement("div", { className: "bdrs:1 bd bd:w:1 bd:c:border-0.2 fz:14 lh:1.5 py:2 px:6 py:6:xl-up px:8:xl-up" },
            React.createElement("span", { className: `d:block h:lh ${sizes[i % sizes.length]}` }))))))));
